import {getCK} from "./storage";

const checkArr = (v) => {
  return getCK("r").includes(v);
};

export default checkArr;
